import { render } from "./save-form.vue?vue&type=template&id=5c54dbea&lang=pug"
import script from "./save-form.vue?vue&type=script&lang=js"
export * from "./save-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__